import { useNavigate } from "react-router-dom"

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs"
import { useDefaulterSearchParams } from "@/hooks"

import { DefaultersRecurringTabContent } from "./recurring-tab-content"
import { DefaultersRotateTabContent } from "./rotate-tab-content"
export const DefaultersTabs = () => {
  const navigate = useNavigate()
  const { params } = useDefaulterSearchParams()
  const handleTabChange = (value: string) => {
    navigate(`/defaulters?tab=${value}`)
  }
  return (
    <Tabs
      defaultValue={params?.tab}
      onValueChange={handleTabChange}
      className="w-full"
    >
      <TabsList>
        <TabsTrigger value="recurring">
          Recorrência
        </TabsTrigger>
        <TabsTrigger value="rotate">Rotativo</TabsTrigger>
      </TabsList>
      <TabsContent value="recurring">
        <DefaultersRecurringTabContent />
      </TabsContent>
      <TabsContent value="rotate">
        <DefaultersRotateTabContent />
      </TabsContent>
    </Tabs>
  )
}
